import './productsListLink2.scss'

interface ProductsListLink2Prop {
   item: {
      name: string;
      id: number;
      images?: string[];
   }
   url: string;
}

function ProductsListLink2({ item, url }: ProductsListLink2Prop) {
   return (
      <a href={`${url}${item.id}`}>
         <img
            className='productsList__img'
            src={item.images && item.images.length > 0 ? item.images[0] : "No image"}
            alt={item.name}
         />
      </a>
   )
}

export default ProductsListLink2